import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation transferSubject($data: transferSubjectInput!, $id: String!) {
    transferSubject(data: $data, id: $id) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const transferSubjectRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {data: TYPES.TransferSubjectInput;id: String;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'subject/transfer_subject',
  async (
  params: {data: TYPES.TransferSubjectInput;id: String;},
  { extra: client }) =>
  {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.transferSubject;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const transferSubjectSlice = createSlice({
  name: 'transfer_subject',
  initialState: initialState,
  reducers: {
    transferSubjectClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(transferSubjectRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(transferSubjectRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(transferSubjectRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { transferSubjectClear } = transferSubjectSlice.actions;

export const transferSubject = createSelector(
  (state: RootState) => state.subject.transferSubject.result,
  (state: RootState) => state.subject.transferSubject.error,
  (state: RootState) => state.subject.transferSubject.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default transferSubjectSlice.reducer;